<button
  b2cElement
  modalType="unselect"
  data-cy="unselect_btn"
  class="unselect-button"
  [title]="config().icon.alternativeText"
  [attr.aria-label]="config().icon.alternativeText"
  (click)="
    displayUnselectDialog(
      phase(),
      challenge(),
      isBisCampaign(),
      isEventChallenge()
    )
  "
>
  <img
    alt=""
    aria-hidden="true"
    class="responsive-width"
    [src]="config().icon.imageUrl"
    [style.width]="config().width || ''"
  />
</button>
